export const routeLinks = {
  viewerTaskDashboard: "/viewer/task",
  viewerProjectTaskDashboard: "/viewer/project",
  //dashboards
  dashboardCommon: "/",
  dashboardCommonOld: "/old-dashboard",
  dashboardTask: "/dashboard/task",
  //auth
  authLogin: "/login",
  authLogout: "/logout",
  authPasswordReset: "/reset-password",
  //admin
  adminUsers: "/users",
  adminUserTask: "/admin/user-task",
  //project management
  projectManagementEnquiry: "/enquiry",
  projectManagementProject: "/project",
  projectManagementProduct: "/product",
  projectManagementFinish: "/finish",

  //Report
  customReports: "/custom-reports",

  // task management
  taskManagementTask: "/task",
  addNewTask: "/new-task",
  //other error pages
  internalServerError: "/500",
  underMaintenance: "/maintenance",
  pageNotFound: "/404",
};
